module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale-region"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.selectradio
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("单个区县")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(" 跨区县 ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("  跨市  ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_vm._v("注：请选择申报单位所在的区县信息")]), _vm._v(" "), _vm._l((_vm.region), function(m, i) {
    return _c('p', {
      key: m.id,
      staticStyle: {
        "margin": "22px 0"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "市"
      },
      on: {
        "change": function($event) {
          _vm.selcity(i)
        }
      },
      model: {
        value: (m.city),
        callback: function($$v) {
          _vm.$set(m, "city", $$v)
        },
        expression: "m.city"
      }
    }, _vm._l((_vm.cityList), function(v) {
      return _c('el-option', {
        key: v.code,
        attrs: {
          "value": v.code,
          "label": v.name
        }
      })
    })), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == 1),
        expression: "type==1"
      }],
      attrs: {
        "placeholder": "区县"
      },
      on: {
        "change": function($event) {
          _vm.result(i)
        }
      },
      model: {
        value: (m.county),
        callback: function($$v) {
          _vm.$set(m, "county", $$v)
        },
        expression: "m.county"
      }
    }, _vm._l((_vm.countyList), function(v) {
      return _c('el-option', {
        key: v.code,
        attrs: {
          "value": v.code,
          "label": v.name
        }
      })
    })), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type != 1),
        expression: "type!=1"
      }],
      attrs: {
        "multiple": "",
        "placeholder": "区县"
      },
      on: {
        "change": function($event) {
          _vm.result(i)
        }
      },
      model: {
        value: (m.countys),
        callback: function($$v) {
          _vm.$set(m, "countys", $$v)
        },
        expression: "m.countys"
      }
    }, _vm._l((_vm.countyList), function(v) {
      return _c('el-option', {
        key: v.code,
        attrs: {
          "value": v.code,
          "label": v.name
        }
      })
    })), _vm._v(" "), (_vm.type == 3) ? _c('el-button', {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "icon": "delete",
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.removeRegion(i)
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.type == 3) ? _c('p', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addRegion
    }
  }, [_vm._v("添加")])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715781e3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/region/ScaleRegion.vue
// module id = 1246
// module chunks = 2